/**
 * 岗位
 */

import { HTTP_ALB } from "../axios";

//  岗位列表
export const getjoblist = (params) => {
  return HTTP_ALB.get("/system/job/list", params);
};

// 添加岗位
export const addjob = (params) => {
  return HTTP_ALB.post("/system/job/add", params);
};
// 编辑岗位
export const editjob = (params) => {
  return HTTP_ALB.post("/system/job/edit", params);
};
